import React from 'react'
import Header from '../Components/Header/Header'
import PlaceOrders from '../Components/PlaceOrder/PlaceOrders'

function PlaceOrder() {
  return (
    <div>
        <Header/>
        <PlaceOrders/>
    </div>
  )
}

export default PlaceOrder